var _class, _descriptor, _descriptor2, _descriptor3, _ForcJournalEventBasedComponent;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
/* eslint-disable ember/no-runloop */
import Store from "@ember-data/store";
import { assert } from "@ember/debug";
import { next } from "@ember/runloop";
import { service } from "@ember/service";
import { dasherize } from "@ember/string";
import ForcBaseComponent from "core/components/forc/abstract/base-component";
import DraftManager from "core/components/forc/draft-manager";
import FormAction from "core/components/forc/form-action";
import BioExamPrescribedJournalEvent from "core/models/bio-exam-prescribed-journal-event";
import BioExamResultsReceivedJournalEvent from "core/models/bio-exam-results-received-journal-event";
import ConsultationReportWrittenJournalEvent from "core/models/consultation-report-written-journal-event";
import DpCycleDeclaredJournalEvent from "core/models/dp-cycle-declared-journal-event";
import File from "core/models/file";
import FileUploadedJournalEvent from "core/models/file-uploaded-journal-event";
import JournalEventModel from "core/models/journal-event";
import MedicalEventJournalEvent from "core/models/medical-event-journal-event";
import MedicalImagingPrescribedJournalEvent from "core/models/medical-imaging-prescribed-journal-event";
import MedicationPrescribedJournalEvent from "core/models/medication-prescribed-journal-event";
import ParamedicalCarePrescribedJournalEvent from "core/models/paramedical-care-prescribed-journal-event";
import Patient from "core/models/patient";
import { Changeset } from "ember-changeset";
import lookupValidator from "ember-changeset-validations";
import { BufferedChangeset, ValidatorAction, ValidatorMap } from "ember-changeset/types";
import FlashMessagesService from "ember-cli-flash/services/flash-messages";
import emberSwal from "ui-kit/utils/ember-swal";
import { ForcBaseArgs } from "./base-component";
let ForcJournalEventBasedComponent = (_class = (_ForcJournalEventBasedComponent = class ForcJournalEventBasedComponent extends ForcBaseComponent {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "flashMessages", _descriptor, this);
    _initializerDefineProperty(this, "requestManager", _descriptor2, this);
    _initializerDefineProperty(this, "store", _descriptor3, this);
    /// USABLE INTERFACE
    /**
     * @type {DraftManager}
     * @private
     */
    _defineProperty(this, "draft", void 0);
    /**
     * An Ember Changeset validator.
     * If set, it is used instead of the default `lookupValidator(this.validations)`.
     */
    _defineProperty(this, "validator", void 0);
    /**
     * Describes the journal event's properties that will be used for load and save.
     */
    _defineProperty(this, "journalEventProperties", []);
    /**
     * If `true`, the content of the changeset is regularly saved in the local
     * storage, and automatically injected when the component is loaded in `new`
     * mode with the same patient and form id.
     */
    _defineProperty(this, "autoSaveDraft", false);
  }
  /**
   * Need to be overwrite by the FORC if we want a custom flash message
   * If you won't a flash message, overwrite it and return null
   *
   */
  get toastMessage() {
    return {
      message: "Information bien enregistrée. Merci !"
    };
  }
  static hasDraftForPatient(patient) {
    return DraftManager.hasDraftFor(DraftManager.localStorageKey(this.fullComponentId, patient));
  }

  /**
   * The full component id, containing the feature name and the component name,
   * for instance "online-consultation/report-edition-form".
   * Ideally, this should be injected by Ember CLI, or the registry, but there
   * is no registry for components, component names are dynamically resolved at
   * runtime when instantiated.
   *
   * Thus, this must be set by developers when inheriting from this class.
   */

  get fullComponentId() {
    const fullComponentId = this.constructor.fullComponentId;
    assert(`The 'fullComponentId' is not defined for the class '${this.constructor.name}`, Boolean(fullComponentId));
    return fullComponentId;
  }

  /**
   * The corresponding model name.
   * TODO: Typescript JournalEventClass generator
   */

  get journalEventClass() {
    return this.constructor.journalEventClass;
  }
  get journalEventClassType() {
    return this.journalEventClass.type;
  }

  /**
   * This property is used to display the forc display name in the timeline or other places,
   * through formWithId hook in parogXX/addon/index.js
   * At launch, the `forc-registration` instance-initializer automatically find and add those forc components
   * to staticForms, so that they can be retrieved as usual forms
   *
   * Thus, you must define this property if you want your forc to be reachable from formWithId.
   */

  get forcDisplayName() {
    return this.constructor.forcDisplayName;
  }
  /// PRIVATE PROPERTIES

  get model() {
    const model = this.retrieveModel();

    // This is the funny memoization pattern.
    // We can't do "delete this.model" because the accessor is defined in the prototype.
    // So we just have to set the property in the instance like this.
    Object.defineProperty(this, "model", {
      value: model,
      writable: false // if one day we need to set the model somewhere else we can set to true
    });
    return this.model;
  }
  afterLoad() {
    return;
  }
  get changeset() {
    const changeset = this.computeChangeset();

    // Memoization :
    Object.defineProperty(this, "changeset", {
      value: changeset,
      writable: false
    });
    this.draft = new DraftManager(this);
    // The load of the draftManager must be called after the "memoization" is done.
    // `this.computeChangeset` creates a Changeset object and consumes its @tracked `_changes` property
    // calling `this.draft.load();` will call changeset.restore and will modified the @tracked `_changes` property
    // This can't be done in the same runloop or you'll get the error
    next(this, function () {
      this.draft.load();
      this.afterLoad();
    });
    return this.changeset;
  }
  get defaultModel() {
    return {};
  }
  get sourceJeId() {
    return this.args.sourceJeId;
  }
  /**
   * An Ember Changeset Validations object
   */
  get validations() {
    Object.defineProperty(this, "validations", {
      value: {}
    });
    return this.validations;
  }
  get sourceJournalEvent() {
    if (this.sourceJeId) {
      const je = this.store.peekRecord(this.journalEventClassType, this.sourceJeId);
      if (je) {
        assert("The patient should be the same as the one in the component.", je.patient?.get("id") == this.patient?.id);
        return je;
      }
      return null;
    }
    return null;
  }

  /**
   * Describes the strategy used to retrieve the Journal Event that will be used as a model.
   * Default strategies can be found in `journal-event-retrieval-strategies`.
   *
   */
  retrieveJournalEvent() {
    return;
  }
  get retrievedJournalEvent() {
    return this.retrieveJournalEvent();
  }

  /// STATE

  get isEditMode() {
    return this.formAction == FormAction.Edit;
  }
  get isNewMode() {
    // We suppose that if we do not have formAction provided we are in new mode.
    return this.formAction == FormAction.New || this.formAction == null;
  }

  /**
   * Will be set by the 'retrieveModel' method if this form has been loaded
   * from an existing je.
   * TODO: Actually this is based on the 'retrievedJournalEvent' accessor which
   *       make a request to the store each time this is called.
   *       We should instead store the retrievedJe or store this in a variable.
   */
  get isLoadedFromJe() {
    return Boolean(this.retrievedJournalEvent);
  }

  /// IMPLEMENTATION

  async isValid() {
    await this.changeset.validate();
    return this.changeset.get("isValid");
  }
  get isDirty() {
    const chatMessageKeys = ["chatMessage", "willSendMessage"];
    return this.changeset.changes.length == 2 && chatMessageKeys.includes(this.changeset.changes[0].key) && chatMessageKeys.includes(this.changeset.changes[1].key) ? false : this.changeset.get("isDirty");
  }

  /**
   * The model will be mutated so do not return a JournalEvent from the store but a copy!
   * By default return the last JournalEvent of the given type.
   * This method is only called once when the model is accessed for the first time.
   */
  retrieveModel() {
    const journalEvent = this.retrievedJournalEvent || this.defaultModel;
    return this.journalEventProperties.reduce((acc, property) => {
      acc[property] = journalEvent[property];
      return acc;
    }, {});
  }

  /**
   * Compute the changeset based on the current model.
   * This method is only called once when the changeset is accessed for the first time.
   * It's possible to override it to add behavior to the changeset.
   */
  computeChangeset() {
    const changeset = Changeset(this.model, this.validator ? this.validator : lookupValidator(this.validations), this.validations);
    changeset.on("afterValidation", () => {
      this.draft.onDidUpdate();
    });
    return changeset;
  }
  async saveWithFiles(journalEventClassType = this.journalEventClassType) {
    this.changeset.execute();
    const payload = this.computePayload();
    const patient = payload.patient;
    delete payload.patient;
    const attrs = Object.fromEntries(Object.entries(payload).map(([k, v]) => [dasherize(k), v]));
    const body = JSON.stringify({
      data: {
        "journal-event": {
          data: {
            type: `${journalEventClassType}s`,
            attributes: attrs,
            relationships: {
              patient: {
                data: {
                  id: patient.id
                }
              }
            }
          }
        },
        "file-attachments": this.changeset.get("files").map(file => file.fileAttachment.serialize()),
        "file-contents": this.changeset.get("files").map(file => file.fileContent.serialize())
      }
    });
    let journalEvent;
    const {
      response,
      content
    } = await this.requestManager.request({
      url: "/api/v1/journal_event_with_attachment",
      method: "POST",
      body: body
    });
    if (!response.ok) {
      emberSwal.fire({
        title: "Oups, échec de l'importation de votre document.",
        text: "Veuillez réessayer ou contacter le support Sêmeia si le problème persiste.",
        icon: "error"
      });
    } else {
      // Fetch saved record
      journalEvent = await this.store.findRecord(content.data.type.slice(0, -1), content.data.id, {
        include: "file-attachments"
      });
    }
    return journalEvent;
  }
  async save() {
    if (this.changeset.get("files")) {
      return await this.saveWithFiles();
    }
    if (!this.isDirty) {
      return;
    }
    let savedModel;
    this.changeset.execute();
    if (this.formAction === FormAction.Edit) {
      const sourceJournalEvent = this.retrievedJournalEvent;
      if (sourceJournalEvent) {
        await sourceJournalEvent.archive();
      }
      savedModel = await this.saveModel();
      if (sourceJournalEvent && sourceJournalEvent.fileAttachments.length > 0) await this.transferFileAttachments(sourceJournalEvent.fileAttachments, savedModel);
    } else {
      savedModel = await this.saveModel();
    }
    await this.draft.onDidSave();
    this.popToast();
    return savedModel;
  }
  popToast() {
    if (this.toastMessage) this.flashMessages.success(this.toastMessage.message, {
      title: this.toastMessage.title
    });
  }

  /**
   * A payload based on the `journalEventProperties`
   */
  computePayload() {
    return this.journalEventProperties.reduce((acc, property) => {
      acc[property] = this.model[property];
      return acc;
    }, {
      patient: this.patient
    });
  }
  async saveModel() {
    // TODO: Create the changeset from a new JournalEvent and then save it
    // Think about removing all the JE with 'isNew' from the store.

    const payload = this.computePayload();
    const journalEventRecord = this.store.createRecord(this.journalEventClassType, payload);
    const newJe = await journalEventRecord.save();
    return newJe;
  }
  async transferFileAttachments(fileAttachments, newJe) {
    await Promise.all(fileAttachments.slice().map(async f => {
      // @ts-expect-error journalEvent is declared as AsyncBelongsTo.
      //   When settings the value, from TypeScript point-of-view,
      //   a promise should be set, while setting the value directly
      //   is actually supported  by Ember Data, and is the official way.
      f.journalEvent = newJe;
      await f.save();
    }));
  }
}, _defineProperty(_ForcJournalEventBasedComponent, "fullComponentId", void 0), _defineProperty(_ForcJournalEventBasedComponent, "journalEventClass", void 0), _defineProperty(_ForcJournalEventBasedComponent, "forcDisplayName", void 0), _ForcJournalEventBasedComponent), _descriptor = _applyDecoratedDescriptor(_class.prototype, "flashMessages", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "requestManager", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { ForcJournalEventBasedComponent as default };